import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-analise-hora-bi05-lista-grid',
  templateUrl: './analise-hora-bi05-lista-grid.component.html',
  styleUrls: ['./../../../../../../../assets/styles/styles.grid-analise.css']
})
export class AnaliseHoraBi05ListaGridComponent implements OnInit {

  analiseHoraTranslate = {
    "Horas M.O Cliente": "rmpv.analiseHora.horasMOCliente",
    "Horas M.O Garantia": "rmpv.analiseHora.horasMOGarantia",
    "Horas M.O Recall": "rmpv.analiseHora.horasMORecall",
    "Horas M.O Revisões": "rmpv.analiseHora.horasMORevisoes",
    "Horas M.O Seguros/Franquias": "rmpv.analiseHora.horasMOSegurosFranquias",
    "Horas M.O Serviços Internos, PDI": "rmpv.analiseHora.horasMOServicosInternosPDI",
    "Horas M.O Outros": "rmpv.analiseHora.horasMOOutros",
    "Horas M.O Retrabalho": "rmpv.analiseHora.horasMORetrabalho",
    "Horas M.O Cortesia": "rmpv.analiseHora.horasMOCortesia",
    "Total de Horas Trabalhadas": "rmpv.analiseHora.totalHorasTrabalhadas",
    "Horas perdidas M.O": "rmpv.analiseHora.horasPerdidasMO",
    "Total de Horas Disponíveis": "rmpv.analiseHora.totalHorasDisponiveis",
    "Horas M.O Treinamento": "rmpv.analiseHora.horasMOTreinamento",
    "Horas M.O Licenças / Faltas / Férias": "rmpv.analiseHora.horasMOLicencasFaltasFerias",
    "Total de Horas Compradas": "rmpv.analiseHora.totalHorasCompradas",
    "Horas Vendidas Cliente": "rmpv.analiseHora.horasVendidasCliente",
    "Horas Vendidas Garantia": "rmpv.analiseHora.horasVendidasGarantia",
    "Horas Vendidas Recall": "rmpv.analiseHora.horasVendidasRecall",
    "Horas Vendidas Revisões": "rmpv.analiseHora.horasVendidasRevisoes",
    "Horas Vendidas Seguros/Franquias": "rmpv.analiseHora.horasVendidasSeguro",
    "Horas Vendidas Outras": "rmpv.analiseHora.horasVendidasOutras",
    "Horas-Extras": "rmpv.analiseHora.horasExtras",
    "Preço Público de M.O - Garantia": "rmpv.analiseHora.precoPublicoMOGarantia",
    "Preço Público de M.O - Clientes": "rmpv.analiseHora.precoPublicoMOClientes",
    "Preço Obtido de M.O - Revisões": "rmpv.analiseHora.precoObtidoMORevisoes",
  }

  @Input() dados: any;
  @Input() anoFiltro: any;

  constructor() { }

  ngOnInit(): void {
  }

  getTranslate(value) {
    return this.analiseHoraTranslate[value];
  }
}
